import { UserState } from 'src/app/global/state/app.reducers';
import { TxState } from './tx.reducer';
import * as TxActions from './tx.actions';
import * as TxSelectors from './tx.selectors';

export interface State extends UserState {
    txState: TxState
}

export { TxActions, TxSelectors };